import request from '@/utils/request'


export function qlSwCircle(params) {
  return request({
    url: '/admin/store/setting/qlSwCle',
    method: 'get',
    params: params
  })
}

export function updateSwCle(data) {
  return request({
    url: '/admin/store/setting/updateSwCle',
    method: 'post',
    data: data
  })
}

export function getOpenBookLevelLimit(params) {
  return request({
    url: '/admin/store/setting/getOpenBookLevelLimit',
    method: 'get',
    params: params
  })
}

export function setOpenBookLevelLimit(params) {
  return request({
    url: '/admin/store/setting/setOpenBookLevelLimit',
    method: 'get',
    params: params
  })
}

export function getStoreRestDay(params) {
  return request({
    url: '/admin/store/setting/getStoreRestDay',
    method: 'get',
    params: params
  })
}
export function setStoreRestDay(data) {
  return request({
    url: '/admin/store/setting/setStoreRestDay',
    method: 'post',
    data: data
  })
}


export function updateVccNotifySwitch(data) {
  return request({
    url: '/admin/store/setting/updateVccNotifySwitch',
    method: 'post',
    data: data
  })
}

export function getVccNotifySwitch(params) {
  return request({
    url: '/admin/store/setting/getVccNotifySwitch',
    method: 'get',
    params: params
  })
}

export function updateClassServiceItem(data) {
  return request({
    url: '/admin/store/setting/updateClassServiceItem',
    method: 'post',
    data: data
  })
}

export function getClassServiceItem(params) {
  return request({
    url: '/admin/store/setting/getClassServiceItem',
    method: 'get',
    params: params
  })
}

export function getClassServiceAllItem(params) {
  return request({
    url: '/admin/store/setting/getClassServiceAllItem',
    method: 'get',
    params: params
  })
}

//查询门店剩余短信
export function getStoreRemVccCounts(params) {
  return request({
    url: '/admin/store/setting/getStoreRemVccCounts',
    method: 'get',
    params: params
  })
}

/**
 * 保存基础排班模板
 * @param data
 */
export function setScheLessonBsTemplate(data) {
  return request({
    url: '/admin/store/setting/setScheLessonBsTemplate',
    method: 'post',
    data: data
  })
}

/**
 * 获取基础排班模板
 * @param data
 */
export function getScheLessonBsTemplate(params) {
  return request({
    url: '/admin/store/setting/getScheLessonBsTemplate',
    method: 'get',
    params: params
  })
}

/**
 * 获取自动发布
 * @param data
 */
export function getAutoRelease(params) {
  return request({
    url: '/admin/store/setting/getAutoRelease',
    method: 'get',
    params: params
  })
}
/**
 * 设置
 * @param data
 */
export function setAutoRelease(params) {
  return request({
    url: '/admin/store/setting/setAutoRelease',
    method: 'get',
    params: params
  })
}
/**
 * 设置基础课程名
 * @param data
 */
export function setBsLessonName(params) {
  return request({
    url: '/admin/store/setting/setBsLessonName',
    method: 'get',
    params: params
  })
}

/**
 * 获取基础课程名
 * @param data
 */
export function getBsLessonName(params) {
  return request({
    url: '/admin/store/setting/getBsLessonName',
    method: 'get',
    params: params
  })
}



/**
 * 设置亲子课程名
 * @param data
 */
export function setFcLessonName(params) {
  return request({
    url: '/admin/store/setting/setFcLessonName',
    method: 'get',
    params: params
  })
}

/**
 * 获取亲子课程名
 * @param data
 */
export function getFcLessonName(params) {
  return request({
    url: '/admin/store/setting/getFcLessonName',
    method: 'get',
    params: params
  })
}



/**
 * 设置一节基础课时间
 * @param data
 */
export function setClassTimeBs(params) {
  return request({
    url: '/admin/store/setting/setClassTimeBs',
    method: 'get',
    params: params
  })
}

/**
 * 获取一节基础课时间
 * @param data
 */
export function getClassTimeBs(params) {
  return request({
    url: '/admin/store/setting/getClassTimeBs',
    method: 'get',
    params: params
  })
}


/**
 * 获取线索设置
 * @param data
 */
export function getClueFollowSetting(params) {
  return request({
    url: '/admin/store/setting/getClueFollowSetting',
    method: 'get',
    params: params
  })
}

/**
 * 保存线索设置
 * @param data
 */
export function setClueFollowSetting(data) {
  return request({
    url: '/admin/store/setting/setClueFollowSetting',
    method: 'post',
    data: data
  })
}





// WEBPACK FOOTER //
// ./src/api/StoreSetting.js